import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AdminAuthguardService } from '../shared/admin-authguard.service';
import { AuthguardService } from '../shared/authguard.service';
import { routes } from './routes';

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [],
  providers: [AuthguardService, AdminAuthguardService],
  declarations: []
})
export class ModulesModule {
  constructor() {}
}
